import React from 'react';
import { isNil } from 'ramda';
import { cFieldNames, initialValues, validationSchema } from './schema';
import { Field, Form, Formik } from 'formik';
import { Grid, MenuItem } from '@material-ui/core';
import { IForm } from '../../types/IForm';
import FieldSelect from '../../components/Form/FieldSelect';
import { SubmitButton } from '../../components/Form/SubmitButton';
import { AuditTypeApiResponse } from '../../types/AuditTypeApiResponse';
import { useTranslation } from '../../contexts/translationContext';

export interface Props extends IForm {
    data?: any | null;
    onSubmit: (e: any) => void;
    auditTypes: AuditTypeApiResponse | undefined;
}

export const ReportSelect5SForm = ({
    data,
    userCanEdit,
    onSubmit,
    goBackUrl,
    auditTypes,
}: Props) => {
    const { t } = useTranslation();
    return (
        <Formik
            enableReinitialize
            initialValues={isNil(data) ? initialValues : data}
            validationSchema={validationSchema(t)}
            onSubmit={(values) => {
                userCanEdit && onSubmit(values);
            }}
        >
            {({ handleChange, handleSubmit }) => (
                <Form onSubmit={handleSubmit} onChange={handleChange}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={12} lg={12}>
                            <Field
                                name={cFieldNames.auditTypeId}
                                label={t('Report.select.audit')}
                                fullWidth
                                component={FieldSelect}
                            >
                                {auditTypes &&
                                    auditTypes.map((a) => (
                                        <MenuItem key={a.id} value={a.id}>
                                            {`${a.name}`}
                                        </MenuItem>
                                    ))}
                            </Field>
                        </Grid>
                        <SubmitButton
                            buttonTitle={t('Show')}
                            visible={userCanEdit}
                            goBackUrl={goBackUrl}
                        />
                    </Grid>
                </Form>
            )}
        </Formik>
    );
};
